var jq = jQuery.noConflict();

var companyVars = JSON.parse(document.getElementById("companyVars").innerText),
    asset_url = companyVars.asset_url,
    website_base_url = companyVars.website_base_url,
    ir_base_url = companyVars.ir_base_url,
    hCaptchaSiteKey = companyVars.hCaptchaSiteKey,
    isQmod = companyVars.isQmod;

// Fires on click or enter keypress
jq.fn.accessibleClick = function (handler) {
    jq(this).on("click keyup", function (event) {
        if (event.type === "keyup") {
            var code = event.which;
            // Don't consider it a click if we don't press enter or spacebar
            if (code !== 32 && code !== 13) {
                return false;
            }
        }
        handler.call(this, event);
    });
};

var captchaIDs = {}; // Holds all hCaptcha elements so that we can use the correct response when there are multiples on a page
function hCaptchaOnLoad() {
    // Add hcaptcha to all forms on a page
    jq(".h-captcha").each(function () {
        var form = jq(this).closest("form");
        window.captchaIDs[form[0].id] = hcaptcha.render(this.id, {
            sitekey: window.hCaptchaSiteKey,
            callback: function (token) {
                // This is the REAL submit for the invisible-hCaptcha flow:
                // jQuery Validate's submitHandler fired earlier and called
                // hcaptcha.execute(), and the POST happens here via the native
                // form.submit() (which bypasses submitHandler). Guard against a
                // double resolve firing two POSTs, mirroring the submitHandler
                // guard. .data() is keyed on the DOM element, so this shares the
                // same flag the submitHandler/else branch set.
                if (form.data("eq-submitting")) {
                    return;
                }
                form.data("eq-submitting", true);
                jq("<input>", {
                    type: "hidden",
                    name: "h-captcha-response",
                    value: token,
                }).appendTo(form);
                form[0].submit();
            },
            // If the challenge errors or the token expires before submit, clear
            // the pending guard so the user isn't permanently blocked from
            // retrying.
            "error-callback": function () {
                form.data("eq-captcha-pending", false);
            },
            "expired-callback": function () {
                form.data("eq-captcha-pending", false);
            },
        });
    });
}

/**
 * Initializes validation for all forms with the "validate-form" class.
 * 
 * This function sets up custom validation rules, error handling, and submission logic
 * using the jQuery Validation plugin.
 */
function validate_forms() {
    // Custom validator: matches the server-side password regex in
    // InvestorPortalRegistrationHandler::register_user(). Keep these in sync.
    if (jq.validator && !jq.validator.methods.passwordStrength) {
        jq.validator.addMethod("passwordStrength", function (value, element) {
            return this.optional(element)
                || /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@$!%*?&])\S{8,128}$/.test(value);
        });
    }

    // jQuery Validate names a grouped or checkable field's error label by the
    // field/group NAME (its idOrName()), not the first input's id — e.g.
    // "eligibility_type[]-error" and "investor_portal_acknowledgments-error". So
    // aria-describedby must point at that label id, and cleanup must resolve the
    // member inputs by name (a group name matches no element id or name on its
    // own). This mirrors the `groups` config below.
    var ariaGroups = {
        investor_portal_acknowledgments: "cert_not_competitor cert_providing_info cert_understands_reserve cert_authority",
    };

    // Resolve the input(s) an error label covers from the label's key (the id
    // jQuery Validate assigned, minus the "-error" suffix). Handles a plain
    // element id, a checkable field name (radio group), and a grouped-checkbox
    // group name.
    function eqResolveFieldInputs(key) {
        if (!key) {
            return jq();
        }
        if (ariaGroups[key]) {
            var selectors = jq.map(ariaGroups[key].split(/\s+/), function (n) {
                return '[name="' + n + '"]';
            });
            return jq(selectors.join(","));
        }
        // Only treat the key as an element id when it's a valid CSS id. A
        // checkbox group's error label is named after the field NAME, so for an
        // array field like "eligibility_type[]" the key contains "[]" — feeding
        // that to a "#id" selector makes Sizzle throw ("unrecognized
        // expression: #eligibility_type[]"), which breaks error rendering on
        // submit and drops the form to a native POST with no hCaptcha token.
        // Resolve those by name instead.
        if (/^[A-Za-z][\w-]*$/.test(key)) {
            var $byId = jq("#" + key);
            if ($byId.length) {
                return $byId;
            }
        }
        return jq('[name="' + key + '"]');
    }

    var validator = jq(".validate-form");
    validator.each(function () {
        var $form = jq(this);
        var formID = $form.attr("id");
        jq(this).validate({
            errorElement: "span",
            errorClass: "error eq-error",
            rules: {
                password: {
                    passwordStrength: true,
                },
                password_confirm: {
                    equalTo: "#password",
                },
                // Eligibility is a checkbox group sharing the name
                // "eligibility_type[]"; required on a checkbox group means at
                // least one must be checked.
                "eligibility_type[]": {
                    required: true,
                },
            },
            messages: {
                password: {
                    passwordStrength: "Password must be 8-128 characters and include an uppercase letter, a lowercase letter, a number, and a special character (#, @, $, !, %, *, ? or &).",
                },
                password_confirm: {
                    equalTo: "Passwords must be the same.",
                },
                "eligibility_type[]": {
                    required: "Please select at least one of the eligibility options that applies to you.",
                },
                cert_not_competitor: {
                    required: "All four acknowledgments above must be checked before you can submit this form.",
                },
            },
            // Treat the four Investor Portal acknowledgment checkboxes as one
            // logical field — emit a single consolidated error message instead
            // of four "this field is required" labels stacked under each box.
            groups: {
                investor_portal_acknowledgments: "cert_not_competitor cert_providing_info cert_understands_reserve cert_authority",
            },
            errorPlacement: function (error, element) {
                // Anchor aria-describedby to the id jQuery Validate actually
                // assigned to the generated label, not element.id + "-error".
                // For radio groups / grouped checkboxes those differ (the label
                // is named by the field/group name), so the old value pointed at
                // a non-existent node and a screen reader announced no error.
                // Apply aria-* to every input the label covers.
                var errorId = error.attr("id");
                var key = errorId ? errorId.replace(/-error$/, "") : null;
                var $described = eqResolveFieldInputs(key);
                if (!$described.length) {
                    $described = element;
                }
                $described.attr("aria-describedby", errorId);
                $described.attr("aria-invalid", "true");

                var name = element.attr("name");
                // Investor Portal eligibility checkboxes — anchor the message
                // after the list (right above the existing "you will not be able
                // to submit unless…" warning) instead of letting jQuery Validate
                // drop it inside the first <li>.
                if (name === "eligibility_type[]") {
                    var $list = element.closest(".eligibility-list");
                    if ($list.length) {
                        error.insertAfter($list);
                        return;
                    }
                }
                // Investor Portal acknowledgment checkboxes — same treatment,
                // anchored under the checkbox list so the consolidated group
                // error sits with the warning copy.
                if (name && name.indexOf("cert_") === 0) {
                    var $certList = element.closest(".certifications-list");
                    if ($certList.length) {
                        error.insertAfter($certList);
                        return;
                    }
                }

                if (element.attr("type") === "radio") {
                    error.prependTo(element.parent());
                } else if (element.parent().hasClass('password-input-wrapper')) {
                    error.insertAfter(element.parent());
                } else {
                    error.appendTo(element.parent());
                }
            },
            success: function (label) {
                // Clear aria-* from the same input(s) errorPlacement set them on.
                // Resolve via the label id (which may be an element id, a radio
                // group name, or a grouped-checkbox group name) so grouped fields
                // get cleared too — the old "#" + id lookup matched nothing for a
                // group name and left aria-invalid stuck on the radios/checkboxes.
                var labelId = label.attr("id") || "";
                var key = labelId.replace(/-error$/, "");
                var $inputs = eqResolveFieldInputs(key);

                $inputs.removeAttr("aria-describedby");
                $inputs.removeAttr("aria-invalid");
                label.remove();
            },
            submitHandler: function (form) {
                var $form = jq(form);
                if (hcaptcha.getResponse(window.captchaIDs[formID])) {
                    // Defense-in-depth against a double-click firing two POSTs
                    // (e.g. two Investor Portal registrations — see the find-then-
                    // create note in InvestorPortalRegistrationHandler). This
                    // branch only runs for an already-valid, captcha-cleared
                    // form that is about to navigate away, so blocking the
                    // repeat and disabling the submit control can never strand a
                    // user on an invalid form. The hCaptcha callback resubmits
                    // programmatically, which still works on a disabled button.
                    if ($form.data("eq-submitting")) {
                        return false;
                    }
                    $form.data("eq-submitting", true);
                    $form
                        .find('button[type="submit"], input[type="submit"]')
                        .prop("disabled", true)
                        .attr("aria-disabled", "true");
                    form.submit();
                } else {
                    // Invisible-hCaptcha path: there is no token yet, so the real
                    // POST will happen later in the render callback's
                    // form.submit() — which never re-enters this submitHandler.
                    // Set the guard HERE so a double-click during captcha solving
                    // can't fire two execute() calls (→ two POSTs); the if-branch
                    // guard above is never consulted on this path. The
                    // error/expired callbacks clear eq-captcha-pending so a failed
                    // challenge can be retried.
                    if ($form.data("eq-captcha-pending") || $form.data("eq-submitting")) {
                        return false;
                    }
                    $form.data("eq-captcha-pending", true);
                    hcaptcha.reset(window.captchaIDs[formID]);
                    hcaptcha.execute(window.captchaIDs[formID]);
                }
            },
            // Scroll and focus on the 1st error input after submitting an invalid form
            invalidHandler: function (event, validator) {
                if (validator.errorList.length >= 1) {
                    let errorElement = validator.errorList[0].element;
                    errorElement.scrollIntoView({ behavior: "instant", block: "center" });
                    errorElement.focus();
                }
            },
        });
    });

    // Custom email validation method
    jq.validator.methods.email = function (value, element) {
        return this.optional(element) || /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value);
    };
}

// Main document ready scripts
jq(document).ready(function () {
    // Basic Form Validation
    validate_forms();
    
    // Pagination
    const paginationMobile = jq("#pagination--mobile");
    if (paginationMobile.length) {
        jq(this)
            .find("#pagination--mobile-select")
            .change(function () {
                var selectedPage = jq(this).val();
                location.href = encodeURI(selectedPage);
            });
    }

    // Add noopener to all links that open in a new tab.
    jq('a[target="_blank"]').each(function () {
        var linkRel = jq(this).attr("rel");
        if (!linkRel || (linkRel && linkRel.indexOf("noopener") == -1)) {
            var newRel = linkRel === undefined ? "" : linkRel;
            newRel += linkRel && linkRel.length ? " noopener" : "noopener";
            jq(this).attr("rel", newRel);
        }
        // Add descriptive text for screen readers if there's not already a title attr set
        if (this.getAttribute("title") === null) {
            this.setAttribute("title", "Opens in a new window");
        }
    });
    addRequiredAsteriskToLabels();

    // Scroll more home hero button
    var scrollMore = document.getElementById("scroll-more");
    var mainContent = document.getElementById("mainContent");
    var scrollTopBtn = document.getElementById("back-to-top-btn");
    
    if (scrollTopBtn) {
        scrollTopBtn.addEventListener('click', () => {
            var animationDistance =
                window.innerWidth <= 991 &&
                header &&
                window.getComputedStyle(header).getPropertyValue("position") !== "fixed"
                    ? 0
                    : jq("#header").outerHeight();
            // Smooth scroll to #mainContent
            jq("html, body").animate(
                {
                    scrollTop: 0,
                },
                "slow"
            );
        });
        let ticking = false;
        document.addEventListener('scroll', () => {
            if (!ticking) {
                setTimeout(() => {
                    checkScroll();
                    ticking = false;
                }, 20);
                ticking = true;
            }
        });
        function checkScroll() {
            const pos = window.scrollY;
            if (pos >= 100) {
                scrollTopBtn.classList.add('active');
            } else {
                scrollTopBtn.classList.remove('active');
            }
        }
    }
    // If #mainContent doesn't exist, hide #scroll-more
    if (!mainContent && scrollMore) {
        scrollMore.style.display = "none";
    } else if (scrollMore) {
        jq(scrollMore).accessibleClick(function (e) {
            e.preventDefault();
    
            // Adjust scroll offset based on header height
            let header = document.querySelector("#header");
            var animationDistance =
                window.innerWidth <= 991 &&
                header &&
                window.getComputedStyle(header).getPropertyValue("position") !== "fixed"
                    ? 0
                    : jq("#header").outerHeight();
    
            // Smooth scroll to #mainContent
            jq("html, body").animate(
                {
                    scrollTop: jq(mainContent).offset().top - animationDistance,
                },
                "slow"
            );
        });
    }

    jq("#header.affixed").affix({
        offset: {
            top: 1,
        },
    });

    //Circle Stat with Percentage Animation
    var divPercentage = jq(".stats-row-w-percents");
    if (divPercentage.length) {
        jq(document).bind("scroll", function (ev) {
            var scrollOffset = jq(document).scrollTop();
            var containerOffset = jq(".stats-row-w-percents").offset().top - window.innerHeight;
            if (scrollOffset > containerOffset) {
                jq(".stats-row-w-percents .stat").each(function () {
                    var percDiv = jq(this).find(".number"),
                        svgElm = jq(this).find(".circle"),
                        percentNumber = jq(this).attr("data-percent");
                    svgElm.attr("stroke-dasharray", percentNumber + ", 100");
                    svgElm.addClass("active");
                    jq({ percentage: 0 })
                        .stop(true)
                        .animate(
                            { percentage: percentNumber },
                            {
                                duration: 2000,
                                step: function () {
                                    var percentageVal = Math.round(this.percentage);
                                    percDiv.text(percentageVal + "%");
                                },
                            }
                        )
                        .promise()
                        .done(function () {
                            percDiv.text(percentNumber + "%");
                        });
                });
                jq(document).unbind("scroll");
            }
        });
    }

    var subNav = jq(".sub-navigation.affixed");
    if (subNav.length) {
        jq(subNav).affix({
            offset: {
                top: jq(".sub-navigation").offset().top - jq("#header").outerHeight(),
            },
        });
    }

    var menuRight = document.getElementById("mobile-nav"),
        showRight = document.getElementById("showRight");

    jq.fn.openMobileRightMenu = function () {
        toggleMenuKeybind();
        jq(".mobile-nav-trigger").toggleClass("active");
        jq("body").toggleClass("push-to-left");
        jq(menuRight).toggleClass("cbp-spmenu-open");
        disableOther("showRight");
        if (jq(".mobile-nav-trigger").hasClass("active")) {
            jq(".mobile-nav-trigger").attr("aria-label", "Close main navigation");
            jq(".mobile-nav-trigger").attr("aria-expanded", "true");
        } else {
            jq(".mobile-nav-trigger").attr("aria-label", "Expand main navigation");
            jq(".mobile-nav-trigger").attr("aria-expanded", "false");
        }
    };
    
    // Disable menu toggle when a link is clicked
    jq(".main-menu a").on("click", function () {
        if (jq(".mobile-nav-trigger").hasClass("active")) {
            jq(".mobile-nav-trigger").removeClass("active");
            jq("body").removeClass("push-to-left");
            jq(menuRight).removeClass("cbp-spmenu-open");
        }
    });

    function disableOther(button) {
        if (button !== "showRight") {
            jq(showRight).toggleClass("disabled");
        }
    }

    /**
     * This function handles keydown events when a full screen nav is present, allowing
     * the navigation to be closed by pressing the esc key
     */
    function toggleMenuKeybind() {
        var $body = jq("body");
        if ($body.hasClass("push-to-left")) {
            $body.off("keydown");
        } else {
            $body.on("keydown", function (e) {
                if (e.which == 27) {
                    jq(".main-nav").toggleClass("active");
                    jq(showRight).toggleClass("active");
                    jq("body").toggleClass("push-to-left");
                    jq(menuRight).toggleClass("cbp-spmenu-open");
                    disableOther("showRight");
                    $body.off("keydown");
                }
            });
        }
    }

    //File input
    var fileInput = jq(".file-text input");
    fileInput.change(function (e) {
        $this = jq(this);
        var val = $this.val().split("\\");
        var length = val.length;
        var filename = val[length - 1];
        jq(this).parent(".file-text").children(".text-wrapper").text(filename);
    });

    // SEC Filing Filters - auto submit form
    jq("#sec-filing-filter select").on("change", function (e) {
        jq(this).closest("form").submit();
    });

    var $filterSelect = jq(".row-filter .eq-select");
    if ($filterSelect.length) {
        $filterSelect.on("change", function () {
            var url = window.location.protocol + "//" + window.location.hostname + window.location.pathname;
            var query = "";
            jq(".row-filter .eq-select").each(function () {
                var prefix = "&";
                if (query.length === 0) {
                    prefix = "?";
                }
                if (jq(this).val() != -1) {
                    query += prefix + jq(this).attr("name") + "=" + jq(this).val();
                }
            });
            url = url + query;
            if (!query) {
                var full_url = url + "?year=" + jq(this).val();
                if (window.location.href != full_url) {
                    window.location.href = full_url;
                }
            } else {
                if (window.location.href != url) {
                    window.location.href = url;
                }
            }
        });
    }

    // Resources module
    if (jq(".module-resources-page").length) {
        var viewModel = new ViewModel(JSON.parse(document.getElementById("resourcesVm").innerText));
    }
    
    // News slider
    if (jq(".news-slider").length) {
        jq(".news-slider").slick(JSON.parse(document.getElementById("newsSlickOptions").innerText));
    }

    // Clearly Ardagh story carousel. Options live on the element so they survive the page cache.
    if (jq(".clearly-ardagh-slider").length && jq.fn.slick) {
        jq(".clearly-ardagh-slider").each(function () {
            var slider = jq(this);
            if (slider.hasClass("slick-initialized")) {
                return;
            }
            var options = slider.attr("data-slick-options");
            if (!options) {
                return;
            }
            slider.slick(JSON.parse(options));
        });
    }

    // SEC Filings expand
    jq(".spr-expandable").hide();
    jq(".spr-toggle-expandable").click(function () {
        jq(this).next(".spr-expandable").toggle("blind");
        jq(this).toggleClass("expanded");
        if (jq(this).hasClass("expanded")) {
            jq(this).attr("aria-pressed", true);
        } else {
            jq(this).attr("aria-pressed", false);
        }
    });

    // Crisis Messaging
    var $majorAnnouncement = jq("#majorAnnouncement");
    var majorAnnouncementCookieName = "eqMajorAnnouncement";
    if ($majorAnnouncement.length) {
        var majorAnnouncementTimestamp = $majorAnnouncement.data("timestamp");
        var majorAnnouncementCookie = Cookies.get(majorAnnouncementCookieName);
        if (majorAnnouncementCookie != majorAnnouncementTimestamp) {
            let announcements = new EqDialog({
                show_close_button: true,
            });
            announcements.open("inline", "majorAnnouncement");
            // Expires should be set to a number of days
            Cookies.set(majorAnnouncementCookieName, majorAnnouncementTimestamp, { secure: true, domain: window.location.hostname, expires: 7 });
        }
    }

    // Add Class to body if there is a scoll bar in the page
    if (jq(document).width() < jq(window).outerWidth()) {
        jq("body").addClass("scrollbar");
    }

    function resize_events() {
        // Fix accessibility issue for main navigation and sub navigation triggers on mobile
        if (window.innerWidth <= 991) {
            jq(".mobile-nav-trigger").attr("tabindex", 0);
            jq(".mobile-sub-nav-trigger").attr("tabindex", 0);
            jq(".cbp-spmenu > .main-menu ul").attr("aria-hidden", "true");
            jq(".cbp-spmenu > .main-menu > li > ul").attr("aria-hidden", "true");
            if (jq(".cbp-spmenu").hasClass("cbp-spmenu-open")) {
                jq(".has-children ul").attr("aria-hidden", "false");
                jq(".has-children ul li a").attr("tabindex", "0");
                jq(".cbp-spmenu > .main-menu > li > a").attr("tabindex", 0);
                jq("#submenu-search-form input, #submenu-search-form button").removeAttr("disabled");
            } else {
                jq(".has-children ul").attr("aria-hidden", "true");
                jq(".has-children ul li a").attr("tabindex", "-1");
                jq(".cbp-spmenu > .main-menu > li > a").attr("tabindex", -1);
                jq("#submenu-search-form input, #submenu-search-form button").attr("disabled", "true");
            }
        } else {
            jq(".mobile-nav-trigger").attr("tabindex", "");
            jq(".mobile-sub-nav-trigger").attr("tabindex", "");
            jq(".has-children ul li a").attr("tabindex", "");
            jq(".has-children ul").attr("aria-hidden", "false");
            jq(".cbp-spmenu > .main-menu > li > ul").attr("aria-hidden", "false");
            jq(".cbp-spmenu > .main-menu > li > a").attr("tabindex", 0);
        }
    }
 
    // Call resize_events() on load
    resize_events();

    jq(window).resize(function (evt) {
        resize_events();
    });

    // Enable accessible clicking on mobile navs and subnavs
    jq(".mobile-nav-trigger").on("click", function (evt) {
        evt.stopPropagation();
        jq(this).openMobileRightMenu();
        resize_events();
        return false;
    });
    // Close mobile nav when selecting the darkened body background
    jq(".cbp-spmenu").accessibleClick(function (evt) {
        evt.stopPropagation();
    });
    jq("body").on("click", function (evt) {
        if (this.classList.contains("push-to-left")) {
            jq(this).openMobileRightMenu();
            resize_events();
            return false;
        }
    });

    // Detect window size change (switching to landscape on tablet
    var windowW = window.innerWidth;
    jq(window).resize(function () {
        windowW = window.innerWidth;
    });

    // Close mobile nav after selecting anchor link, make selected link use active class
    jq(".main-menu > .has-children > a").accessibleClick(function (e) {
        if (windowW >= 992) return;
        // Remove any existing active classes
        if (this.parentElement.classList.contains("active")) {
            this.parentElement.classList.remove("active");
            return;
        }
        jq(".main-menu > .has-children").each(function () {
            this.classList.remove("active");
        });
        this.parentElement.classList.add("active");
    });

    jq("#mobile-nav ul a").accessibleClick(function (e) {
        if (windowW >= 992) return;
        let navMenu = document.getElementById("mobile-nav");
        jq("#mobile-nav").toggleClass("cbp-spmenu-open");
        jq("body").toggleClass("push-to-left");
        jq("#showRight").toggleClass("active");
    });

    jq(".mobile-sub-nav-trigger").accessibleClick(function (evt) {
        // We want to use the accessibleClick method so that the logic surrounding
        // keys is consistent; however, avoid recursion by causing an infinite click loop
        if (evt.type != "click") {
            jq(this).click();
            return false;
        }
    });

    //Accessible click for Financial Results collapse elements
    jq(".quarterly-results [role=button]").accessibleClick(function (evt) {
        // We want to use the accessibleClick method so that the logic surrounding
        // keys is consistent; however, avoid recursion by causing an infinite click loop
        if (evt.type != "click") {
            jq(this).click();
            return false;
        }
    });

    //Expand/Collapse all button for Financial Results
    var FinancialResultsExpandBtn = jq(".expand-all-quarters");
    var QuarterHeaders = jq(".quarterly-results .header");

    FinancialResultsExpandBtn.on("click", function (e) {
        //If elements are collapsed, expand the rest
        if (jq(this).text() == "Expand All") {
            QuarterHeaders.filter(".collapsed").click();
        } else {
            //Otherwise collapse them all
            QuarterHeaders.filter(":not(collapsed)").click();
        }
    });

    QuarterHeaders.on("click", function (e) {
        if (FinancialResultsExpandBtn.length) {
            //Allow for collapse animation to complete
            //setTimeout(functionRef, delay, param1, param2)
            setTimeout(updateExpandBtnText, 200, FinancialResultsExpandBtn, ".quarterly-results .header");
        }
    });

    // Allows upload of cover letter via styled link by triggering hidden upload/input field
    jq("#cover_letter").on("click", function (e) {
        e.preventDefault();
        jq("#upload_cover_letter:hidden").trigger("click");
    });

    // Chart Library Functionality
    jq(".chart-table-expander").on("click", function (e) {
        e.target.classList.toggle("hidden");
        e.target.parentElement.querySelector(".chart-legend").classList.toggle("hidden");
    });

    // Remove width from table headers with only a superscript
    jq(".report .th").each(function () {
        // Extract the innerHTML
        const innerContent = jq(this).html().trim();

        // Use a regex to check if content matches <sup> with a number, asterisk, or these wrapped in square brackets
        const regex = /^<sup>(\[\d+\]|\d+|\[\*\]|\*)<\/sup>$/;
        if (regex.test(innerContent)) {
            jq(this).css({
                width: "0%",
                "padding-left": "0",
            });
        }
    });

    /**
     * Accessibility Fix for Radio Inputs
     **/
    let radioLabels = document.querySelectorAll(".eq-radio label");

    radioLabels.forEach(function (radioLabel) {
        radioLabel.setAttribute("tabindex", "0"); // Ensure labels are focusable

        radioLabel.addEventListener("keydown", function (e) {
            // Check if the key pressed is the spacebar
            if (e.key === " " || e.keyCode === 32) {
                e.preventDefault();
                let associatedRadio = document.getElementById(this.getAttribute("for"));
                // Check if the associated radio button exists and is not already checked
                if (associatedRadio && !associatedRadio.checked) {
                    associatedRadio.checked = true;
                    associatedRadio.dispatchEvent(new Event("change"));
                }
            }
        });
    });
    // MOBILE MENU TRAP FOCUS
    let lastNavItem = jq(".main-menu > li.last-item");
    let mobileTrigger = jq(".mobile-nav-trigger");
    // Normal Tab
    lastNavItem.on("keydown", function (e) {
        if (!e.shiftKey && e.key === "Tab" && mobileTrigger.hasClass("active")) {
            e.preventDefault();
            mobileTrigger.focus();
        }
    });
    // Shift + Tab
    mobileTrigger.on("keydown", function (e) {
        if (e.shiftKey && e.key === "Tab" && mobileTrigger.hasClass("active")) {
            e.preventDefault();
            lastNavItem.focus();
        }
    });
    //CCPA Request Form
    jq('#ccpa-request-form input[name="claim"]').change(function () {
        let value = jq(this).val();
        if (value == "Resident") {
            jq(".show-resident").removeClass("hide");
            jq(".show-representative").addClass("hide");
            jq("#certify_resident").addClass("required");
            jq("#certify_resident").attr("aria-required", "true");
            jq(".show-representative .conditional-required, #certify_representative").removeClass("required");
            jq(".show-representative .conditional-required, #certify_representative").removeClass("error");
            jq(".show-representative .conditional-required, #certify_representative").removeAttr("aria-required");
        } else if (value == "Representative") {
            jq(".show-representative").removeClass("hide");
            jq(".show-resident").addClass("hide");
            jq("#certify_resident").removeClass("required");
            jq("#certify_resident").removeClass("error");
            jq("#certify_resident").removeAttr("aria-required");
            jq(".show-representative .conditional-required, #certify_representative").addClass("required");
            jq(".show-representative .conditional-required, #certify_representative").attr("aria-required", "true");
        }
    });

    // Check for multiple forms and update ids to avoid duplicates.
    //
    // IMPORTANT: previously this block suffixed EVERY input's id with
    // `_${formIndex}` whenever the page had more than one <form>, even when
    // the IDs were already unique. That silently broke jQuery Validate rules
    // like `equalTo: "#password"` (selector kept pointing at the old, now
    // renamed element) and any custom JS that targeted form inputs by id.
    // Now we only rename inputs whose id is genuinely duplicated across the
    // form set.
    let forms = jq("form");
    if (forms.length > 1) {
        const idCounts = {};
        forms.find("input[id]").each(function () {
            const id = this.id;
            idCounts[id] = (idCounts[id] || 0) + 1;
        });
        forms.each(function (formIndex, form) {
            jq(form)
                .find("input[id]")
                .each(function () {
                    const currentId = this.id;
                    if (idCounts[currentId] > 1) {
                        const uniqueId = `${currentId}_${formIndex}`;
                        jq(this).attr("id", uniqueId);
                        jq(form).find(`label[for="${currentId}"]`).attr("for", uniqueId);
                    }
                });

            var $password = jq(form).find('input[name="password"]');
            var $confirm = jq(form).find('input[name="password_confirm"]');
            var validator = jq(form).data("validator");
            if (validator && $password.length && $confirm.length) {
                $confirm.rules("remove", "equalTo");
                $confirm.rules("add", { equalTo: "#" + $password.attr("id") });
            }
        });
    }

    jq(".collapse").on("shown.bs.collapse", function (event) {
        // Get the content element within the collapsed section
        let contentElement = jq(this).find(".text")[0];

        if (contentElement) {
            // Check if the content is not in the viewport before scrolling
            if (!isElementInViewport(contentElement)) {
                // Scroll to reveal the content
                contentElement.scrollIntoView({
                    behavior: "smooth",
                    block: "end",
                    inline: "nearest",
                });
            }
        }
    });

    // Initialize dialogs
    let eq_dialogs = new EqDialog();
    eq_dialogs.init();

    //email alerts button eventlistener
    document.querySelector('.btn[href="#email-alerts-cta-form"]')?.addEventListener('click', function() {
        if (this.getAttribute('aria-expanded') === 'false') {
            const header = document.getElementById('header');
            const navHeight = (header ? header.offsetHeight : 0) + 20;
            const buttonTop = this.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
              top: buttonTop - navHeight,
              behavior: 'smooth'
            });
        }
    });
    
}); // end document.ready

// Function to check if an element is in the viewport
function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}

// Adds asterisk to the labels of required form inputs
function addRequiredAsteriskToLabels() {
    jq("form .required")
        .siblings("label")
        .each(function () {
            let currentText = jq(this).text();
            jq(this).text(currentText + "*");
        });
}

/**
 * addCustomErrorFormHandlers
 *
 * Sets up custom error handling for forms, specifically targeting required
 * checkboxes and radio button groups. Displays error messages and applies
 * border styling to elements that fail validation. Enhances accessibility by
 * updating ARIA attributes based on user interactions.
 *
 * - Applies different border colors for elements within dark-themed sections.
 * - Adds or removes error messages and styles based on validation results.
 * - Updates ARIA attributes for better accessibility.
 */

function addCustomErrorFormHandlers() {
    const BORDER_COLOR_LIGHT = "#D40033";
    const BORDER_COLOR_DARK = "#FA003A";

    // Listen for form submission
    jq("form").on("submit", function (e) {
        jq("ul.checkboxes.required, ul.radios.required").each(function () {
            let type = jq(this).hasClass("checkboxes") ? "checkbox" : "radio";
            let borderColor = jq(this).closest(".dark").length > 0 ? BORDER_COLOR_DARK : BORDER_COLOR_LIGHT;

            // Check if any input of the correct type in this group is checked
            if (jq(this).find('input[type="' + type + '"]:checked').length === 0) {
                jq(this).css("border", "1px solid " + borderColor);

                // Link error to checkbox/radio group
                let errorId = jq(this).parent().attr("aria-labelledby") + "-error";
                jq(this).parent().attr("aria-describedby", errorId);

                // Add error message if it does not already exist
                if (jq(this).siblings(".eq-error").length === 0) {
                    jq(this).after(`<span class="eq-error" id="${errorId}">This field is required</span>`);
                }
            } else {
                // Remove the border and error message if any input is checked
                jq(this).css("border", "");
                jq(this).siblings(".eq-error").remove();
                jq(this).parent().removeAttr("aria-describedby");
            }
        });
    });

    // Event handler for changes to checkboxes and radio buttons in all groups
    jq(document).on("change", 'ul.checkboxes input[type="checkbox"], ul.radios input[type="radio"]', function () {
        let ul = jq(this).closest("ul.checkboxes, ul.radios");

        // Update ARIA attributes for accessibility
        if (jq(this).attr("type") === "radio") {
            // Set aria-checked for all radio buttons in the group
            ul.find('input[type="radio"]').attr("aria-checked", "false");
            jq(this).attr("aria-checked", "true");
        } else {
            jq(this).attr("aria-checked", this.checked);
        }

        // Check if any input in this group is checked
        if (ul.find("input:checked").length > 0) {
            // If an input is checked, remove the border and error message
            ul.css("border", "");
            ul.siblings(".eq-error").remove();
        }
    });

    // Initialize ARIA attributes on page load
    jq('ul.checkboxes input[type="checkbox"], ul.radios input[type="radio"]').each(function () {
        jq(this).attr("aria-checked", this.checked);
    });
}

// Call the function to setup event handlers once the document is ready
jq(document).ready(function () {
    addCustomErrorFormHandlers();
});

//SMOOTH SCROLL
// Scrolling when accesing an URL with a hash in there
jq(document).ready(() => {
    let windowLocationHash = window.location.hash;
        let hashElement = jq(windowLocationHash);
        if (hashElement.length) {
            let offset = 0;
            let header = jq("#header");
            let subNav = jq(".sub-navigation");
            if (header.length) {
                offset += header.outerHeight();
            }
            if (subNav.length) {
                offset += subNav.outerHeight();
            }
            jq("html,body").animate(
                {
                    scrollTop: hashElement.offset().top - offset,
                },
                300
            );
        }
});
// Smooth scroll animation when a link containing # in the href is clicked
jq('a[href*="#"]').on("click", function (event) {
    // Check for any anchor links we want to ignore
    if (jq(this).hasClass("chart-legend-trigger") || jq(this).hasClass("accordion-btn") || jq(this).hasClass("eq-dialog") || jq(this).closest(".tab-header").length) {
        return; // Exit the function early if ignored links are found
    }

    // Check if the href contains #
    if (this.hash !== "") {
        // Prevent default anchor click behavior for regular anchor links
        // Only prevent default anchor behavior if it is targeting the current page
        if (this.href == window.location.href) {
            event.preventDefault();
        }

        // Store hash
        let hash = this.hash;
        let id = hash.split("#")[1];

        // Call the named function smoothScrollToHash for regular anchor links
        // If the target is a collapsed box, wait for it to open
        let el = document.getElementById(id);
        if (el && el.classList.contains("panel-collapse")) {
            setTimeout(() => {
                smoothScrollToHash(hash);
            }, 100);
        } else {
            smoothScrollToHash(hash);
        }
    }
});
function smoothScrollToHash(hash, custom_offset = 0) {
    if (hash.length) {
        let hashElement = jq(hash);
        if (hashElement.length) {
            let offset = 0;
            let header = jq("#header");
            let subNav = jq(".sub-navigation");
            if (header.length) {
                offset += header.outerHeight();
            }
            if (subNav.length) {
                offset += subNav.outerHeight();
            }
            jq("html,body").animate(
                {
                    scrollTop: hashElement.offset().top - (offset + custom_offset),
                },
                800
            );
        }
    }
}

//Check if any target elements are collapsed
function elementsAreCollapsed(selector = "[data-toggle='collapse']") {
    if (jq(selector + ".collapsed").length) {
        return true;
    } else {
        return false;
    }
}

function updateExpandBtnText(btn, collapseTarget) {
    if (!btn) {
        return;
    }
    if (elementsAreCollapsed(collapseTarget)) {
        btn.text("Expand All");
    } else {
        btn.text("Collapse All");
    }
}

// Checkbox Groups
jq('[id^=ir-sec-all]').change(function () {
    const parentCheckbox = jq(this);
    const childCheckboxes = parentCheckbox.closest('.eq-checkbox').find(".ir-sec-sub");

    if (parentCheckbox.is(":checked")) {
        // Check and disable all children
        childCheckboxes
            .prop("checked", true)
            .prop("disabled", true)
            .attr('aria-checked', true)
            .removeAttr("checked");
    } else {
        // Uncheck and enable all children
        childCheckboxes
            .prop("checked", false)
            .prop("disabled", false)
            .attr('aria-checked', false)
            .removeAttr("checked");
    }
});

// Auto-uncheck parent if any child is unchecked
jq(".ir-sec-sub").change(function () {
    const parentCheckbox = jq("#ir-sec-all");
    const childCheckboxes = parentCheckbox.closest('.eq-checkbox').find(".ir-sec-sub");

    if (!jq(this).is(":checked")) {
        parentCheckbox
            .prop("checked", false)
            .attr('aria-checked', false)
            .removeAttr("checked");
    } else {
        // If all children are checked, check the parent
        const allChecked = childCheckboxes.toArray().every((checkbox) => checkbox.checked);
        parentCheckbox
            .prop("checked", allChecked)
            .attr('aria-checked', allChecked);

        if (allChecked) {
            parentCheckbox.attr("checked", "checked");
        } else {
            parentCheckbox.removeAttr("checked");
        }
    }
});

// Timeline
var $timelineEl = jq(".module-timeline");
if ($timelineEl.length) {
    var timeline = {
        resizePoints: function () {
            if (jq(window).outerWidth() < 768) return;
            jq(".point-wrapper").each(function () {
                var point = jq(this).find(".point");
                jq(this).css("height", point.outerHeight() / 1.2);
            });
        },
    };
    // Once we"re done resizing, calculate the height for the points.
    var resizeTimer;
    jq(window).on("resize", function (e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(timeline.resizePoints, 250);
    });
    timeline.resizePoints();
}
//Add Class to body if page has scrollbar
jq(window).on("resize", function (e) {
    if (jq(document).width() < jq(window).outerWidth()) {
        jq("body").addClass("scrollbar");
    } else {
        jq("body").removeClass("scrollbar");
    }
});
// Scroll More CTA templates
var scrollMore = document.getElementById("scroll-more-alt");
if (scrollMore) {
    jq(scrollMore).accessibleClick(function (e) {
        e.preventDefault();
        var target = jq("#scroll-more-anchor");
        jq("html,body").animate(
            {
                scrollTop: target.offset().top - jq("#header").height(),
            },
            "slow"
        );
    });
}
/**
 * Balance Sheet Page - Income Statement Page - Cash Flow Page
 *
 * Replaces <a> elements within report table with <span> elements.
 * Removes 'href' and 'onclick' attributes from these elements &
 * adds the original 'a' class back to it.
 */
document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector(".report")) {
        // Find the table with class 'report'
        const reportTable = document.querySelector(".report");

        if (reportTable) {
            // Find all <td> elements containing <a> elements
            const tdWithLinks = reportTable.querySelectorAll("td a");

            // Transform each <a> into a <span>
            tdWithLinks.forEach((aElement) => {
                const span = document.createElement("span");
                span.innerHTML = aElement.innerHTML;
                aElement.parentNode.replaceChild(span, aElement);
                span.classList.add("a");
            });
        }
    }
});

// Accesibility Form
let formCounter = 0;
jq(".add-request").accessibleClick(function () {
    formCounter++;
    let newFields = '<div class="info-block">' + '<div class="form-group">' + '<label for="url-' + formCounter + '">URL of requested document or webpage:</label>' + '<input type="text" name="url-' + formCounter + '" id="url-' + formCounter + '" value="" class="required form-control" placeholder="ex. https://www.website.com/page" />' + "</div>" + '<div class="form-group">' + '<label for="description-' + formCounter + '">Description of request or issue related to URL:</label>' + '<textarea name="description-' + formCounter + '" id="description-' + formCounter + '" value="" class="required form-control" placeholder="Enter a description of your request or issue related to the URL inputted above"></textarea>' + "</div>" + "</div>";
    jq(".request-info").append(newFields);
    jq("#url-" + formCounter).focus();
});

/**
 * Global - Decorative Image Alt Check
 *
 * This will check all images across the site to see if the image has a
 * empty or missing alt attribute. If so, aria-hidden="true" will be set.
 */
jq("img").each((ind, el) => {
    // Check if the image has empty or no alt attribute
    if (!jq(el).attr("alt") || jq(el).attr("alt").trim() === "") {
        // If the alt text is empty or not present, set aria-hidden="true"
        jq(el).attr("aria-hidden", "true");
    }
});

/**
 * Row Scripts
 *
 * These are specific to rows in template
 */

// Row News Financial Results Event
jq(document).ready(function () {
    // Scroll more home hero button
    let scrollMore = document.getElementById("scroll-more-midtown");
    if (scrollMore) {
        jq(scrollMore).accessibleClick(function (e) {
            e.preventDefault();
            let target = jq("#scroll-more-anchor");
            jq("html,body").animate(
                {
                    scrollTop: target.offset().top - jq("#header").height(),
                },
                "slow"
            );
        });
    }
});

/**
 * Footnotes Functionality
 */
const createSuperscriptLink = (id) => `<a href="#footnoteDesc${id}" aria-describedby="footnoteDesc${id}" tabindex="0" data-footnote="${id}" class="span-asterisk"><sup>*</sup></a>`;
let footnoteCounter = 0;
function processFootnotesInSection(stats, footnotes) {
    // Processing of footnotes
    footnotes.forEach((footnote) => {
        if (footnote.textContent.trim().startsWith("*")) {
            footnote.outerHTML = `<p id="footnoteDesc${++footnoteCounter}" class="footnote-desc" aria-label="Footnote ${footnoteCounter}" role="status" tabindex="0">${footnote.innerHTML}</p>`;
        }
    });
    // Link asterisks in stats to footnotes
    stats.forEach((stat) => {
        let localCounter = footnoteCounter - 1;
        stat.innerHTML = stat.innerHTML.replace(/\*/g, () => createSuperscriptLink(++localCounter));
    });
}
function processAllFootnotes() {
    const sections = document.querySelectorAll(".container");
    sections.forEach((section) => {
        const stats = section.querySelectorAll(".stat p, .stat-box p");
        const footnotes = section.querySelectorAll(".financial-disclaimer .financial-text p, .source p");
        processFootnotesInSection(stats, footnotes);
    });
}

document.addEventListener('DOMContentLoaded', processAllFootnotes);

/**
 * Adjusts the scroll position to ensure the focused element is visible within the viewport.
 *
 * The function checks if the element is above the visible area or below the viewport,
 * and if so, it adjusts the scroll position to bring the element into view with extra space.
 */
function adjustScrollPosition(e) {
    const headerHeight = document.querySelector("#header").offsetHeight;
    const extraSpace = 80;
    const totalHeight = headerHeight + extraSpace;
    const elementTop = e.target.getBoundingClientRect().top;
    const elementBottom = e.target.getBoundingClientRect().bottom;

    let is_affixed = jq(e.target).closest(".affix").length;

    if (!is_affixed && (elementTop < totalHeight || elementBottom > window.innerHeight)) {
        window.scrollTo({
            top: elementTop + window.scrollY - totalHeight,
            behavior: "smooth",
        });
    }
}

document.addEventListener("keydown", (e) => {
    if (e.key === "Tab" && e.shiftKey) {
        document.addEventListener("focusin", adjustScrollPosition);
    } else {
        document.removeEventListener("focusin", adjustScrollPosition);
    }
});

/**
 * Dynamically wrap tables inside news articles utilizing the Table Wrapper library
 */
document.querySelectorAll(".full-news-article table, .financials table").forEach((table, index) => {
  // Create the parent wrapper
  const parentWrapper = document.createElement("div");
  parentWrapper.className = "tw-parent";
  parentWrapper.setAttribute("data-aria-label", `Table ${index + 1}`);

  // Wrap the table inside the parent wrapper
  table.parentNode.insertBefore(parentWrapper, table);
  parentWrapper.appendChild(table);
});

/**
 * Enables keyboard navigation for tabs within a .tab-header element.
 *
 * Key Features:
 * - Navigation wraps around when reaching the first or last tab.
 * - Focus is moved to the new tab, and the `click` event is triggered to activate it.
 * - Prevents default behavior for smoother keyboard interactions.
 */
document.addEventListener('keydown', (event) => {
    // Check if the focus is inside a .tab-header element
    const activeTab = document.activeElement.closest('.tab-header .nav-link');
    if (!activeTab) return;

    const tabHeader = activeTab.closest('.tab-header');
    const tabs = Array.from(tabHeader.querySelectorAll('.nav-link'));
    const currentIndex = tabs.indexOf(activeTab);

    let newIndex = -1;

    if (event.key === 'ArrowRight') {
        // Move to the next tab
        newIndex = (currentIndex + 1) % tabs.length;
    } else if (event.key === 'ArrowLeft') {
        // Move to the previous tab
        newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    }

    if (newIndex >= 0) {
        event.preventDefault();
        // Update tabindex for all tabs
        tabs.forEach(tab => tab.setAttribute('tabindex', '-1'));
        // Activate the new tab
        const newTab = tabs[newIndex];
        newTab.setAttribute('tabindex', '0');
        newTab.focus();
        newTab.click();
    }
});

/**
 * Update tabindex when tabs are activated via click.
 * This ensures only the active tab is in the tab order.
 */
document.addEventListener('DOMContentLoaded', () => {
    const tabHeaders = document.querySelectorAll('.tab-header');
    tabHeaders.forEach(tabHeader => {
        const tabs = Array.from(tabHeader.querySelectorAll('.nav-link'));
        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                // Set all tabs to tabindex="-1"
                tabs.forEach(t => t.setAttribute('tabindex', '-1'));
                // Set the clicked tab to tabindex="0"
                tab.setAttribute('tabindex', '0');
            });
        });
    });
});

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}
/**
 * Enables keyboard activation of CTA Email Alert buttons.
 *
 * It should work with both space and enter keys
 */
document.addEventListener('DOMContentLoaded', function () {
    const links = document.querySelectorAll('a.email-alerts-btn');
    links.forEach(function (link) {
      link.addEventListener('keydown', function (event) {
        if (event.key === ' ' || event.key === 'Spacebar') { // Spacebar for older browsers
          event.preventDefault(); // Prevent page scroll
          link.click();
        }
      });
    });
  });

/**
 * Run a callback once the DOM is ready. Unlike a bare
 * `addEventListener('DOMContentLoaded', ...)`, this also fires the callback
 * synchronously if the document is already past the loading state — which
 * matters when scripts.js is loaded with `defer` or appended late and the
 * DOMContentLoaded event has already passed.
 */
function whenReady(fn) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn);
    } else {
        fn();
    }
}

/**
 * Investor Portal registration form: show the shareholder section only when the
 * "Beneficial Owner of Shares" eligibility checkbox is checked, and toggle the
 * `required` attribute on its inputs so jQuery Validate / native validation
 * skips them otherwise.
 */
function initInvestorPortalRegisterForm() {
    var form = document.getElementById('investor-portal-register-form');
    if (!form) return;

    var shareholderSection = document.getElementById('shareholder-section');
    if (!shareholderSection) return;

    var shareholderInputs = shareholderSection.querySelectorAll('[data-shareholder-required]');
    var eligibilityBoxes = form.querySelectorAll('input[name="eligibility_type[]"]');

    function syncShareholder() {
        var isShareholder = Array.prototype.some.call(eligibilityBoxes, function (box) {
            return box.checked && box.getAttribute('data-eligibility-value') === 'Beneficial Owner of Shares';
        });
        shareholderSection.hidden = !isShareholder;
        shareholderInputs.forEach(function (input) {
            if (isShareholder) {
                input.setAttribute('required', 'required');
                input.classList.add('required');
            } else {
                input.removeAttribute('required');
                input.classList.remove('required');
                input.value = '';
            }
        });
    }

    eligibilityBoxes.forEach(function (b) {
        b.addEventListener('change', syncShareholder);
    });
    syncShareholder();
}
whenReady(initInvestorPortalRegisterForm);

/**
 * Generic password show/hide toggle. Each `.password-toggle-btn` looks up its
 * <input> via the nearest `.password-input-wrapper` so it doesn't depend on
 * `document.getElementById()`, which can break if a sibling script renames
 * IDs (we used to suffix every input id with `_${formIndex}` on multi-form
 * pages — see the duplicate-id block in the ready handler above).
 */
function initPasswordToggles() {
    var buttons = document.querySelectorAll('.password-toggle-btn');
    buttons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            var wrapper = btn.closest('.password-input-wrapper');
            var input = wrapper ? wrapper.querySelector('input') : null;
            if (!input) return;
            var showIcon = btn.querySelector('.password-toggle-icon--show');
            var hideIcon = btn.querySelector('.password-toggle-icon--hide');
            var isVisible = input.type === 'text';
            input.type = isVisible ? 'password' : 'text';
            btn.setAttribute('aria-pressed', String(!isVisible));
            btn.setAttribute('aria-label', isVisible ? 'Show password' : 'Hide password');
            if (showIcon && hideIcon) {
                showIcon.hidden = !isVisible;
                hideIcon.hidden = isVisible;
            }
        });
    });
}
whenReady(initPasswordToggles);

/**
 * Investor Portal: revalidate #password_confirm whenever #password changes, so
 * a stale "Passwords must be the same." error clears immediately once the two
 * values actually match (the default jQuery Validate binding only revalidates
 * the confirm field on its own keyup/blur, not when the source field is the
 * one being edited).
 */
function initInvestorPortalPasswordSync() {
    var form = document.getElementById('investor-portal-register-form');
    if (!form) return;
    var pw = form.querySelector('input[name="password"]');
    var pwc = form.querySelector('input[name="password_confirm"]');
    if (!pw || !pwc) return;

    pw.addEventListener('input', function () {
        if (window.jq && pwc.value && jq(form).data('validator')) {
            jq(pwc).valid();
        }
    });
}
whenReady(initInvestorPortalPasswordSync);

/**
 * Investor Portal admin review: block a double-click on the Approve / Deny
 * buttons from firing two approval POSTs (which would send the registrant two
 * notification emails). The form has no client-side validation, so a submit
 * event always means a real submission is in flight. Disabling is deferred to
 * the next tick so the clicked button's name/value (action=approve|deny) is
 * still serialized into THIS submission; it only blocks a second click.
 *
 * Defense-in-depth only — server-side this can't fully close the concurrent
 * cross-server window (see Form Submit - Investor Portal Approval.php).
 */
function initApprovalDoubleSubmitGuard() {
    var forms = document.querySelectorAll('form.approval-actions');
    forms.forEach(function (form) {
        form.addEventListener('submit', function (e) {
            if (form.dataset.eqSubmitting === 'true') {
                e.preventDefault();
                return;
            }
            form.dataset.eqSubmitting = 'true';
            window.setTimeout(function () {
                form.querySelectorAll('button[type="submit"]').forEach(function (btn) {
                    btn.disabled = true;
                    btn.setAttribute('aria-disabled', 'true');
                });
            }, 0);
        });
    });
}
whenReady(initApprovalDoubleSubmitGuard);